import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PlatformLogo from '../../shared/PlatformLogo';

// Premium sticky header for the nroute landing.
// Colors reference platform brand tokens (--brand-*). onRequestAccess scrolls to the form.
export default function NrouteLandingHeader({ onRequestAccess, loginHref }) {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: 'How it works', href: '#how-it-works' },
    { label: 'What you get', href: '#features' },
  ];

  return (
    <header
      className={`fixed top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled ? 'border-white/10 backdrop-blur-md' : 'border-transparent'
      }`}
      style={scrolled ? { backgroundColor: 'color-mix(in srgb, var(--brand-bg) 85%, transparent)' } : undefined}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <button onClick={() => navigate('/')} className="flex items-center gap-2.5" aria-label="nroute home">
          <PlatformLogo size={34} showName={false} />
          <span className="text-lg font-semibold tracking-tight text-white">
            <span style={{ color: 'var(--brand-secondary)' }}>∑n</span>-route
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={() => document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' })}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-white"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <button
            onClick={() => navigate(loginHref)}
            className="rounded-lg px-3 py-2 text-sm font-medium text-slate-200 transition-colors hover:text-white"
          >
            Sign in
          </button>
          <button
            onClick={onRequestAccess}
            className="rounded-lg px-4 py-2 text-sm font-semibold shadow-lg transition-all hover:brightness-105 hover:shadow-[0_0_24px_rgba(232,168,56,0.35)]"
            style={{ backgroundColor: 'var(--brand-secondary)', color: 'var(--brand-primary)' }}
          >
            Request access
          </button>
        </div>
      </div>
    </header>
  );
}
